<template>
    <div class="border-b-1 border-gray my-2"></div>
</template>

<script setup lang="ts">
</script>
